import { memo } from 'preact/compat'

import { Typography } from 'components/UI/atoms'

type Props = {
	title: string
}

const DAppFormHeader = memo(({ title }: Props) => (
	<div class='max-w-64'>
		<Typography class='pr-5' color='text-product' text={title} variant='h2' />
		<Typography
			class='mt-5 !font-bold'
			color='text-black-200'
			text='Assign a name and description.'
			variant='text2'
		/>
		<Typography
			color='text-black-200'
			text='The name can only contain letters, numbers, and hyphens.'
			variant='text2'
		/>
	</div>
))

export { DAppFormHeader }
